<template>
	<v-card class="mb-4">
		<v-card-title>
			<v-row>
				<v-col cols="11">	
					<v-text-field v-model="part.name" label="Name"></v-text-field>
				</v-col>
				<v-col cols="1">
					<v-btn icon @click="collapse = !collapse"><v-icon>{{ collapse ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon></v-btn>
				</v-col>
			</v-row>
		</v-card-title>
		<v-card-text class="assessmentPart" :class="{hide: collapse}">
			<v-text-field v-model="part.description" label="Description"></v-text-field>
			<v-list>			
				<v-list-group no-action class="elevation-1"> 
					<v-list-item  dense class="px-2" slot="activator">
						<v-list-item-content>
							<v-list-item-title><span class="mr-4">Sections</span>
								<v-badge color="green" :content="part.sections.length || '0'"></v-badge>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item-icon>
					</v-list-item-icon>
					<v-list-item v-for="section in part.sections" :key="section.id">
							<v-list-item-icon class="mr-4">
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>{{ section.name }}</v-list-item-title>
							</v-list-item-content>
					</v-list-item>
				</v-list-group>
			</v-list>
		</v-card-text>
		<v-card-actions>
			<v-chip class="ma-1" :color="part.sections.length ? 'green' : 'lightGrey'" dark small>{{part.sections.length || 0}} sections</v-chip>
			<v-spacer></v-spacer>	
			<v-btn icon color="red" dark @click="remove(part)"><v-icon>mdi-delete</v-icon></v-btn>
			<v-btn icon color="primary" dark @click="move(part, 'up')"><v-icon>mdi-arrow-up-circle</v-icon></v-btn>
			<v-btn class="mr-2" icon color="primary" dark @click="move(part, 'down')"><v-icon>mdi-arrow-down-circle</v-icon></v-btn>
			<v-dialog v-model="add_section_dialog" width="500">
				<template v-slot:activator="{ on }">
					<v-btn small rounded color="green" dark v-on="on">Add Section</v-btn>
				</template>						
				<v-card>
					<DialogTitle title="Add Section" @close="add_section_dialog = false"></DialogTitle>
					<v-card-text>
						<AddSectionsToPart :part="part" @close="add_section_dialog = false "></AddSectionsToPart>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-card-actions>
	</v-card>

</template>

<style lang="less">
	.assessmentPart{
		display: auto;
		transition: display 0.1s;
		&.hide{
			display: none;
			transition: display 0.1s;
		}
	}
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import DialogTitle from "@/components/elements/DialogTitle"
	import AddSectionsToPart from "@/components/admin/forms/AddSectionsToPart"
	export default {
		name: "PartForm", 
		props: {
			part: {type: Object}
		},
		data: () => {
			return {
				collapse: true,
				add_section_dialog: false, 
				add_sections: [],
			}
		},
		components: {
			DialogTitle, AddSectionsToPart
		},
		computed: {
			...Vuex.mapState({
				surveys: state => state.surveys
			})
		},
		methods: {
			move( part, direction ){
				this.$store.dispatch("assessmentSettings/movePart", {id: part.id, direction: direction});
			},
			remove(part){
				this.$store.dispatch("assessmentSettings/removePart", part.id );
			}
		}
		// created(){
			
		// }

	}
</script>